import { useState } from 'react';
import { Form } from 'antd';
import { useQuery } from '@apollo/client/react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { SUPER_STICKY_TEMPLATES } from 'queries/superStickyTemplates';

const buildMessage = (stickyText, incident) => {
  if (!stickyText) {
    return '';
  }
  return incident ? `${stickyText} | Incident #: ${incident}` : stickyText;
};

const useFraudTemplates = (form, noteFieldName) => {
  const { enableStickyFraudTemplates } = useFlags();
  const [incidentNumber, setIncidentNumber] = useState('');
  const [selectedStickyText, setSelectedStickyText] = useState('');
  const selectedFraudType = Form.useWatch('fraudType', form);
  const createFraudSticky = Form.useWatch('createFraudSticky', form);

  const { data: templatesData } = useQuery(SUPER_STICKY_TEMPLATES, {
    variables: { category: 'FRAUD' },
    skip: !enableStickyFraudTemplates,
  });

  const templates = templatesData?.superStickyTemplates || [];

  const updateNote = (stickyText, incident) => {
    form.setFieldsValue({
      [noteFieldName]: buildMessage(stickyText, incident),
    });
  };

  const onFraudTypeChange = (value) => {
    if (!value) {
      setSelectedStickyText('');
      setIncidentNumber('');
      form.setFieldsValue({ [noteFieldName]: '' });
      return;
    }
    const template = templates.find((t) => t.name === value);
    const stickyText = template?.stickyText || '';
    setSelectedStickyText(stickyText);
    updateNote(stickyText, incidentNumber);
  };

  const onIncidentChange = (e) => {
    const value = e.target.value;
    setIncidentNumber(value);
    if (selectedStickyText) {
      updateNote(selectedStickyText, value);
    }
  };

  const onFraudStickyChange = (checked) => {
    if (!checked) {
      form.setFieldsValue({ [noteFieldName]: '', fraudType: undefined });
      reset();
    }
  };

  const reset = () => {
    setIncidentNumber('');
    setSelectedStickyText('');
  };

  return {
    enabled: enableStickyFraudTemplates,
    createFraudSticky,
    templates,
    incidentNumber,
    selectedFraudType,
    selectedStickyText,
    onFraudTypeChange,
    onFraudStickyChange,
    onIncidentChange,
    reset,
  };
};

export default useFraudTemplates;
